import {pick, compose} from 'ramda'
import {
  INTERMEDIARY_SHAREHOLDER_INPUTFIELD_NAMES,
  FIELD_NAME_TO_PROPERTY_NAME_MAPPING,
} from './constants'

export const pickAllIntermediaryShareHolderProperties = pick(
  INTERMEDIARY_SHAREHOLDER_INPUTFIELD_NAMES
)

const propertyToFieldName = (propertyName: string): string => {
  if (Object.values(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).includes(propertyName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return Object.entries(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).find(
      ([, value]) => value === propertyName
    )![0]
  }
  return `shareholdingCompany.${propertyName}`
}

const fieldNameToProperty = (fieldName: string): string => {
  if (FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]) {
    return FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]
  }
  return fieldName.replace('shareholdingCompany.', '')
}

export const mapIntermediaryShareholderToRequest = (
  formData: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [fieldNameToProperty(fieldName), value])
  )

const mapIntermediaryShareholderPropertiesToInputFieldNames = (
  shareHoldingCompany: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(shareHoldingCompany).map(([propertyName, value]) => [
      propertyToFieldName(propertyName),
      value,
    ])
  )

export const mapIntermediaryShareholderCompanyToFormData = compose(
  pickAllIntermediaryShareHolderProperties,
  mapIntermediaryShareholderPropertiesToInputFieldNames
)
